import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, X } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, user, realUser, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating || !user) return null;

  return (
    <div className="w-full bg-amber-400 text-rs-off-black flex items-center justify-between px-4 py-1.5 z-50 shrink-0">
      <div className="flex items-center gap-2">
        <Eye size={20} />
        <span>
          Viewing as <span className='font-semibold'>{user.first_name} {user.last_name}</span>
          {user.company_name ? <> &mdash; {user.company_name}</> : null}
          {user.email ? <span className="opacity-70 ml-2 font-normal">({user.email})</span> : null}
        </span>
      </div>
      <button
        className="flex items-center gap-1 text-sm bg-rs-off-black text-rs-off-white hover:bg-rs-off-black/70 px-2.5 py-1 rounded font-semibold"
        onClick={() => { stopImpersonation(); navigate('/user-management'); }}
      >
        <X size={13} />
        Back to {realUser?.first_name ?? 'Admin'}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
